export default {
  copyright: "All right reserved. Code Nidus © {year}"
};
